import _ from "lodash";
import DiagramUtils from "../../utils/DiagramUtils";
import CollectionModel from '../CollectionModel';
import Envelope from "../../utils/Envelope";
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends CollectionModel {

    constructor(opts = {}) {
        super();

        super.registerEvent("onClick", "鼠标点击");
        super.registerEvent("onMouseDown", "鼠标按下");
        super.registerEvent("onMouseUp", "鼠标弹起");


        this.width.value = 250;
        this.height.value = 250;

        this.defineAllProperties();
        this.initialize(opts);
    }

    getType() {
        return "GroupModel";
    }
}
